/**
 * Utility functions for Move node components
 */

/**
 * Compare sibling orders for sorting
 */
export const compareSiblingOrders = (a, b) => {
  const intA = parseInt(a, 10);
  const intB = parseInt(b, 10);
  return intA - intB;
};

/**
 * Calculate global node number by type for child nodes
 */
export const calculateGlobalNodeNumberByType = (targetChild, nodeType, preloadedData, compareSiblingOrders) => {
  if (!preloadedData || !targetChild || !nodeType) return null;
  
  const normalizedType = nodeType === 'canvas' ? 'canva' : nodeType;
  let counter = 0;

  const sortedSections = [...preloadedData].sort((a, b) => {
    const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
    const orderB = b.sibling_order || b.procedure_tree?.sibling_order;
    const orderCompare = compareSiblingOrders(orderA, orderB);
    if (orderCompare !== 0) return orderCompare;
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    return dateB - dateA;
  });

  // Count all nodes of this type before this one across all sections, steps, and substeps
  for (let i = 0; i < sortedSections.length; i++) {
    const section = sortedSections[i];

    for (let j = 0; j < (section.steps?.length || 0); j++) {
      const step = section.steps[j];

      // Count step-level children
      const stepChildren = step.children?.filter((c) => c.type === normalizedType) || [];

      // Check if this is our target child in a step
      const targetChildInStep = stepChildren.find((c) => {
        const childId = c.detail?.canvas_tree_node_id || c.tree_node_id;
        return childId === targetChild.tree_node_id || 
               childId === (targetChild.detail?.canvas_tree_node_id || targetChild.tree_node_id) ||
               c.tree_node_id === targetChild.tree_node_id;
      });
      if (targetChildInStep) {
        // Add children before this one in the step
        const childIndex = stepChildren.findIndex((c) => {
          const childId = c.detail?.canvas_tree_node_id || c.tree_node_id;
          return childId === targetChild.tree_node_id || 
                 childId === (targetChild.detail?.canvas_tree_node_id || targetChild.tree_node_id) ||
                 c.tree_node_id === targetChild.tree_node_id;
        });
        counter += childIndex !== -1 ? childIndex : 0;
        return counter + 1;
      } else {
        counter += stepChildren.length;
      }

      // Count substep-level children
      for (let k = 0; k < (step.substeps?.length || 0); k++) {
        const substep = step.substeps[k];
        const substepChildren = substep.children?.filter((c) => c.type === normalizedType) || [];

        // Check if this is our target child in a substep
        const targetChildInSubstep = substepChildren.find((c) => {
          const childId = c.detail?.canvas_tree_node_id || c.tree_node_id;
          return childId === targetChild.tree_node_id || 
                 childId === (targetChild.detail?.canvas_tree_node_id || targetChild.tree_node_id) ||
                 c.tree_node_id === targetChild.tree_node_id;
        });
        if (targetChildInSubstep) {
          // Add children before this one in the substep
          const childIndex = substepChildren.findIndex((c) => {
            const childId = c.detail?.canvas_tree_node_id || c.tree_node_id;
            return childId === targetChild.tree_node_id || 
                   childId === (targetChild.detail?.canvas_tree_node_id || targetChild.tree_node_id) ||
                   c.tree_node_id === targetChild.tree_node_id;
          });
          counter += childIndex !== -1 ? childIndex : 0;
          return counter + 1;
        } else {
          counter += substepChildren.length;
        }
      }
    }
  }
  return counter + 1;
};

